import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=38f0c1ee&"
import script from "./Platform.vue?vue&type=script&async=true&defer=true&lang=js&"
export * from "./Platform.vue?vue&type=script&async=true&defer=true&lang=js&"
import style0 from "./Platform.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports